import zainab from "./assets/zainab.png";
import nneka from "./assets/nneka.png";
import bode from "./assets/bode.png";
import yusuf from "./assets/yusuf.png";
import dami from "./assets/dami.png";
import daniel from "./assets/daniel.png";

export const Avatar = [
  {
    src: zainab,
    title: "zainab",
  },
  {
    src: nneka,
    title: "nneka",
  },
  {
    src: bode,
    title: "bode",
  },
  {
    src: yusuf,
    title: "yusuf",
  },
  {
    src: dami,
    title: "dami",
  },
  {
    src: daniel,
    title: "daniel",
  },
];

export const summer = {
  tac: [
    {
      sn: "1",
      title: "Eligibility",
      subtitle:
        " This competition is open to MTN subscribers aged 15 to 21 years only. Participants must have a valid MTN mobile number to be eligible    ",
    },
    {
      sn: "2",
      title: "Weekly Subscription",
      subtitle: `To access the weekly quizzes and participate in the competition, participants must make a weekly subscription to our platform. Only active subscribers will be allowed to play.`,
    },
    {
      sn: "3",
      title: "Quiz Participation",
      subtitle:
        "Participants must answer the quiz questions honestly and to the best of their knowledge. Cheating or using any unfair means to gain an advantage is strictly prohibited and will lead to disqualification.    ",
    },
    {
      sn: "4",
      title: "Prize Claim",
      subtitle:
        "Winners will be announced every week, and top performers will be eligible for prizes. Winners must come to our office to claim their prizes within 7 days after announcement.",
    },
    {
      sn: "5",
      title: "Past Winners",
      subtitle:
        "Winners of past 9ijakids competitions are not eligible to win in the 5 weeks of summer fun",
    },
    {
      sn: "6",
      title: "Personal Information",
      subtitle:
        "Participants consent to the collection and use of their personal information for the purpose of administering the competition and delivering prizes.",
    },
    {
      sn: "7",
      title: "Publicity",
      subtitle:
        "By participating, participants grant us the right to use their names and images for promotional purposes related to the competition.",
    },
    {
      sn: "8",
      title: "Disqualification",
      subtitle:
        "We reserve the right to disqualify any participant who violates these terms and conditions or engages in any fraudulent or suspicious activities.",
    },
    {
      sn: "9",
      title: "Changes and Termination",
      subtitle:
        "We reserve the right to modify, suspend, or terminate the competition at any time.",
    },
    {
      sn: "10",
      title: "Governing Law",
      subtitle:
        "The competition and these terms and conditions are governed by the laws of Nigeria.",
    },
  ],

  faq: [
    {
      sn: "1",
      title: "How can I participate in the quiz competitions?",
      summary:
        "All you need to do is subscribe on the MTN by using the texting “9IJA” to 8012. A weekly subscription of N50 will give you access to the quizzes",
    },
    {
      sn: "2",
      title: "What are the age categories eligible for the quiz competitions?",
      summary:
        "The quiz competitions are open to participants aged 15 to 21 years.",
    },
    {
      sn: "3",
      title: "How often can I play the quizzes?",
      summary:
        "There is no limit on the number of times you can play the quiz for the week. As a subscriber, you can play the quizzes as many times as you want during the period when the quiz is available. Only your highest score will be used.",
    },
    {
      sn: "4",
      title: "How long will the 5 Weeks of Summer Fun campaign last?",
      summary:
        "The campaign will run for a total of 6 weeks, starting from Monday, 16th August and concluding on Saturday, 23rd September, 2023.",
    },
    {
      sn: "5",
      title: "When does the quiz go live each week",
      summary:
        "The quiz starts on 12 noon every Monday and closes by 12 midnight every Sunday.",
    },
    {
      sn: "6",
      title: "Can I play the quizzes offline?",
      summary:
        "No, the quizzes require an internet connection to access and participate. Make sure you have a stable internet connection to fully enjoy the quiz competitions.",
    },
    {
      sn: "7",
      title: "How are the winners selected?",
      summary:
        "Winners are selected based on scores in the quizzes. The highest scores will top the leaderboard. Top performers each week will be eligible for prizes. And grand prize winner will be determined by the end of the campaign",
    },
    {
      sn: "8",
      title: "How can I track my progress and scores in the quizzes?",
      summary:
        "When you login, you can see your position on the leaderboard, rank and highest score.",
    },
    {
      sn: "9",
      title: "How do I claim my prize if I win?",
      summary:
        "If you are a winner, you will be announced on our platform and contacted. You will need to come to our office to claim your prize within the specified timeframe if the prize is physical.",
    },
    {
      sn: "10",
      title: "Once the challenge has started, Can I still join in?",
      summary:
        "Yes, there are prizes to be won weekly and you are welcome to participate. However, the overall winner is calculated base on scores for the first to the last week. So joining late will affect your chances of winning the overall prize.",
    },
  ],
  rules: [
    {
      sn: "1",
      text: "Only MTN subscribers are eligible to participate in the competition.",
    },
    {
      sn: "2",
      text: "Participants must be aged between 13 and 21 years old to join the 5 Weeks of Summer Fun competition.",
    },
    {
      sn: "3",
      text: "To enter the weekly quizzes, participants must make a weekly subscription to the MTN 9ijakids platform.",
    },
    {
      sn: "4",
      text: "Winners will be announced on our website and social media platforms every Sunday by 5 PM.",
    },
    {
      sn: "5",
      text: "Participants must provide accurate and valid contact information to be eligible for prize redemption.",
    },
    {
      sn: "6",
      text: "Participants must claim their prizes in person at our office within 7 days of being announced as winners.",
    },
    {
      sn: "7",
      text: "Prizes are non-transferable and cannot be exchanged for cash or any other alternatives.",
    },
    {
      sn: "8",
      text: "9ijakids reserves the right to disqualify any participant who violates the competition rules or engages in fraudulent activities.",
    },
  ],
  how: [
    {
      sn: "1",
      text: "Text 9IJA to 8012 (Only available to MTN subscribers)",
    },
    {
      sn: "2",
      text: "Play the quiz for the week",
    },
    {
      sn: "3",
      text: "Unlimited play for ₦‎50 weekly",
    },
    {
      sn: "4",
      text: "New quizzes are released weekly",
    },
    {
      sn: "5",
      text: "You have the opportunity to play multiple times and aim for the top spot on the leaderboard. Your position on the leaderboard is determined by your highest score.",
    },
    {
      sn: "6",
      text: "Weekly winners will be announced every Monday",
    },
    {
      sn: "7",
      text: "Overall grand winners to be announced at the end of the campaign – 26th September 2023",
    },
  ],
};
export const trivia = {
  
  tacs: [
    {
      sn: "1",
      title: "Eligibility: ",
      subtitle:
        "This competition is open to MTN subscribers only. Participants must have a valid MTN mobile number to be eligible.",
    },
    {
      sn: "2",
      title: "Subscription: ",
      subtitle: ` To access the quizzes and participate in the competition, 
      participants must make a daily subscription of ₦100 or weekly subscription
      of ₦200 to our platform. Only subscribers with an active subscription will 
      be allowed to play.`,
    },
    {
      sn: "3",
      title: "Quiz Participation: ",
      subtitle: ` Participants must answer the quiz questions to earn 
      points. Cheating or using any unfair means to gain an advantage is strictly
      prohibited and will lead to disqualification.`,
    },
    {
      sn: "4",
      title: "Timing Per Question: ",
      subtitle: `Each question is timed. You need to answer before
      the time elapsed. Once the time elapses, it moves to the next question.`,
    },
    {
      sn: "5",
      title: "Points Surprises: ",
      subtitle: `Users can earn bonus points within the platform by 
      consistent play, number of attempts, referrals and any other criteria 
      introduced by the game provider.`,
    },
    {
      sn: "6",
      title: "Prize Claim: ",
      subtitle: ` Winners will be announced every week, and top performers 
      will be eligible for cash prizes.`,
    },
    {
      sn: "7",
      title: "Personal Information: ",
      subtitle: `Participants consent to the collection and use of 
      their personal information for the purpose of administering the 
      competition and delivering prizes.`,
    },
    {
      sn: "8",
      title: "Publicity: ",
      subtitle: ` By participating, participants grant us the right to use their 
      nicknames and avatars for promotional purposes related to the 
      competition.`,
    },
    {
      sn: "9",
      title: "Payment: ",
      subtitle: `Prizes will be paid only to the account bearing the name of the 
      users. Therefore, all users must provide accurate account details that 
      matches with their names.`,
    },
    {
      sn: "10",
      title: "Multiple Account Policy: ",
      subtitle:
        "Users are strictly prohibited from operating or  accessing multiple accounts simultaneously while engaging with our platform. <br/> Each individual user must maintain only one active account during their usage of our services. Violation of this policy may result in immediate      termination of all associated accounts without prior notice, and the user  may be permanently banned from accessing our platform. <br/> We reserve the right to employ various means, including but not limited to IP address tracking, device identification, and user behaviour analysis, to detect and investigate instances of multiple account usage. ",
    },
    {
      sn: "11",
      title: "Unauthorized Account Activity: ",
      subtitle: `If users suspect any unauthorized 
      account activity via their account, they are encouraged to promptly report 
      their concerns to our designated support team.`,
    },
    {
      sn: "12",
      title: "Disqualification: ",
      subtitle: `We reserve the right to disqualify any participant who 
      violates these terms and conditions or engages in any fraudulent or 
      suspicious activities.`,
    },
    {
      sn: "13",
      title: "Changes and Termination",
      subtitle: `The game provider reserves the right to 
      amend, modify, suspend, terminate, or otherwise change the competition 
      or these terms and conditions at any time.`,
    },
    {
      sn: "14",
      title: "Governing Law",
      subtitle: `The competition and these terms and conditions are 
      governed by the laws of Nigeria.`,
    },
  ],
  rules: [
    {
      sn: "1",
      text: "Only MTN subscribers are eligible to participate in the competition.",
    },
    {
      sn: "2",
      text: "To enter the competition, participants must make a daily subscription of  ₦100 or weekly subscription of ₦200 to the MTN 9ijakids platform.",
    },
    {
      sn: "3",
      text: `Winners for the week will be announced on our website every Monday`,
    },
    {
      sn: "4",
      text: `Participants must provide accurate and valid account information that 
      matches with their contact information during registration to be eligible for
      prize redemption.`,
    },
    {
      sn: "5",
      text: `Prizes are non-transferable and cannot be exchanged for any other 
      alternatives.`,
    },
    {
      sn: "6",
      text: `You can earn bonus points based on consistent play, number of attempts, 
      referrals and any other criteria introduced by the game provider.`,
    },
    {
      sn: "7",
      text: `You can increase your chance of winning the more times you play.`,
    },
    {
      sn: "8",
      text: `Weekly quiz starts on Monday, 12:00AM WAT and closes by 11:59PM WAT on Sunday.`,
    },
    {
      sn: "9",
      text: `Winners are based on position of the leaderboard as at the close of the 
      quiz`,
    },
    {
      sn: "10",
      text: `Users are strictly prohibited from operating or accessing multiple accounts
      simultaneously while engaging with our platform. Violation of this policy 
      may result in immediate termination of all associated accounts without 
      prior notice, and the user may be permanently banned from accessing our 
      platform.`,
    },
    {
      sn: "11",
      text: `9ijakids reserves the right to disqualify any participant who violates the 
      competition rules or engages in fraudulent activities.`,
    },
  ],
  hows: [
    {
      sn: "1",
      text: `Sign up on <a href="http://qwizfun.ng">http://qwizfun.ng</a> (This is available to MTN 
      subscribers only)`,
    },
    {
      sn: "2",
      text: `Input your phone number, name, and username.`,
    },
    {
      sn: "3",
      text: `Make a subscription of ₦100 daily or ₦200 weekly. You will have to renew 
      your subscription at the end of each day/ week to continue playing.`,
    },
    {
      sn: "4",
      text: `Once you start the quiz, you will be presented with multiple-choice 
      questions. Read the quiz questions carefully and click on your desired 
      answer to proceed to the next question.`,
    },
    {
      sn: "5",
      text: `Each question is timed. You need to answer before the time elapsed. Once 
      the time elapses, it moves to the next question.`,
    },
    {
      sn: "6",
      text: `After completing the quiz, you will see your score with an option to view 
      leaderboard, play again or visit homepage.`,
    },
    {
      sn: "7",
      text: `The leaderboard is updated in real-time, displaying your name, score, and 
      current position. `,
    },
    {
      sn: "8",
      text: `The high score and attempt card displays your highest score and the 
      number of times you have attempted the quiz.`,
    },
    {
      sn: "9",
      text: `The contact us button is your gateway to get assistance and guidance 
      whenever you need it. Please feel free to engage with us.`,
    },
    {
      sn: "10",
      text: `You can earn more points within the platform by consistent play, number 
      of attempts, referrals and any other criteria introduced by the game 
      provider.`,
    },
  ],

  tac:[
    {
    "sn": 1,
    "title": "Introduction",
    "subtitle": "Welcome to the 9ijakids platform, a fun digital learning space that provides educational games and content for children (ages 3 to 15)."
    },
    {
    "sn": 2,
    "title": "Eligibility",
    "subtitle": "Using the 9ijakids platform, you confirm that you are not a person barred from receiving services under the laws of the applicable jurisdiction."
    },
    {
    "sn": 3,
    "title": "License To Use Our Site",
    "subtitle": "We grant you a limited, non-exclusive, non-transferable license to access and use the 9ijakids platform solely for your personal educational purposes."
    },
    {
    "sn": 4,
    "title": "Fair Use",
    "subtitle": "You will not use the site or service for commercial purposes or use it in any way that is unlawful or harms us or any other person or entity as determined by the Company."
    },
    {
    "sn": 5,
    "title": "Content Disclaimer",
    "subtitle": "The content on the 9ijakids platform, including games, materials, and information, is provided 'as is' for educational purposes."
    },
    {
    "sn": 6,
    "title": "Sales and Marketing",
    "subtitle": "Any purchases made on the platform, including subscriptions or in-game items, are subject to our sales policies."
    },
    {
    "sn": 7,
    "title": "Warranty Disclaimer",
    "subtitle": "We always try to keep our site and services available, bug-free and safe. However, you use it at your own risk."
    },
    {
    "sn": 8,
    "title": "Limitation of Liability",
    "subtitle": "Under no circumstance shall we be liable for any direct, indirect, incidental punitive, consequential, special or exemplary damages."
    },
    {
    "sn": 9,
    "title": "Indemnification",
    "subtitle": "You agree to indemnify and hold harmless 9ijakids, its affiliates, officers, and employees from any claims, damages, liabilities, losses, or expenses arising from your use of the platform."
    },
    {
    "sn": 10,
    "title": "Force Majeure",
    "subtitle": "9ijakids shall not be liable for any failure or delay in performance resulting directly or indirectly from acts of nature, forces or causes beyond our reasonable control."
    },
    {
    "sn": 11,
    "title": "Breaches of These Terms",
    "subtitle": "Without prejudice to other rights accruable to us under these terms, any breach of these terms will warrant our institution of such measures that we deem your access to and/or use of the site."
    },
    {
    "sn": 12,
    "title": "Termination",
    "subtitle": "We reserve the right to terminate or suspend your access to the 9ijakids platform at any time, with or without notice, for any reason."
    },
    {
    "sn": 13,
    "title": "Updates, Modifications, and Amendments",
    "subtitle": "9ijakids may update, modify, or amend these terms of use at any time."
    },
    {
    "sn": 14,
    "title": "Notices",
    "subtitle": "All legal notices or demands to or upon us shall be made in writing and sent to us personally, by courier, certified mail, to our registered address."
    },
    {
    "sn": 15,
    "title": "Governing Law and Dispute Resolution",
    "subtitle": "These Terms of Use shall be interpreted and governed by the laws currently in force in Nigeria."
    },
    {
    "sn": 16,
    "title": "Severability and Miscellaneous Provisions",
    "subtitle": "If any provision of these terms is found to be unlawful or unenforceable, it will not affect the enforceability of the remaining provisions."
    },
    {
    "sn": 17,
    "title": "Contact Us",
    "subtitle": "If you have any questions, concerns, or feedback regarding these terms of use of the 9ijakids platform, please contact us."
    }
    ],

    privacy:[
    {
    "sn": 1,
    "title": "Protected Personal Information",
    "subtitle": "Your personal information, such as your name, email address, phone number, and other identifying details, is protected and will only be used as described in this Privacy Policy."
    },
    {
    "sn": 2,
    "title": "Collection of Personal Data of Children by 9ijakids",
    "subtitle": "We are committed to protecting the privacy of children. Personal data of children is collected only with parental consent, in compliance with applicable regulations."
    },
    {
    "sn": 3,
    "title": "Information Provided Directly by You",
    "subtitle": "We may collect certain information about you provided directly to us, such as when you request information, create, modify, or lodge a complaint, complete a 9ijakids online form, survey, or questionnaire, or contact customer support."
    },
    {
    "sn": 4,
    "title": "Information Collected Through Your Use of Our Services",
    "subtitle": "We may collect certain information about you, your activity on our Website, and your computer or device when using our services."
    },
    {
    "sn": 5,
    "title": "Information Collected from Third-Party Sources",
    "subtitle": "We may receive information about you from third-party sources, such as social media platforms, VAS aggregators or Telco service providers, to enhance your experience on our platform."
    },
    {
    "sn": 6,
    "title": "Protective Measures We Use",
    "subtitle": "We employ robust security measures to protect your personal information, including encryption, firewalls, and secure server access."
    },
    {
    "sn": 7,
    "title": "The Legal Basis and Reasons for Collection and Processing Your Personal Information",
    "subtitle": "We collect and process your personal information based on your consent, the need to fulfil a contract, or our legitimate interests in improving our services."
    },
    {
    "sn": 8,
    "title": "How We Use the Information We Collect",
    "subtitle": "Our primary purpose in collecting, holding, using and disclosing your Information is for our legitimate business purposes and to provide you with a safe, smooth, efficient, and customised experience."
    },
    {
    "sn": 9,
    "title": "How We Disclose Information We Collect",
    "subtitle": "We may disclose the information we collect about you as described in this Privacy Policy or as described at the time of collection or sharing."
    },
    {
    "sn": 10,
    "title": "Aggregated Data",
    "subtitle": "Aggregated data is de-identified or anonymised and does not constitute Personal Data."
    },
    {
    "sn": 11,
    "title": "Sharing Information with Law Enforcement",
    "subtitle": "9ijakids is committed to cooperating with law enforcement while respecting everyone’s right to privacy."
    },
    {
    "sn": 12,
    "title": "Social Media Sharing",
    "subtitle": "Any information or content you voluntarily disclose for posting publicly to a social sharing service becomes available to the public."
    },
    {
    "sn": 13,
    "title": "User Content and Public Sharing",
    "subtitle": "Share content or post a comment or message that contains personally identifiable information to a page on our service that is accessible to the public."
    },
    {
    "sn": 14,
    "title": "Account Information",
    "subtitle": "You can update your account information anytime by accessing your profile from the avatar on our platform."
    },
    {
    "sn": 15,
    "title": "Promotional Information Opt-Out",
    "subtitle": "You may opt out of receiving promotional messages from us at any time by following the instructions in those messages."
    },
    {
    "sn": 16,
    "title": "Your Access and Rights to Your Personal Information",
    "subtitle": "You have the right to access, correct, or update the personal information we store."
    },
    {
    "sn": 17,
    "title": "Violation of Privacy",
    "subtitle": "We have put in place procedures to deal with any suspected personal data breach."
    },
    {
    "sn": 18,
    "title": "Our Information Retention Policy",
    "subtitle": "Unless you request that we delete certain information, we retain the information we collect for as long as your account is active or as needed to provide services."
    },
    {
    "sn": 19,
    "title": "Contact Us",
    "subtitle": "If you have any questions or concerns about this Privacy Policy or how we handle your personal information, please contact us."
    },
    {
    "sn": 20,
    "title": "Consent",
    "subtitle": "By using the 9ijakids platform, you acknowledge that you have read and understood this Privacy Policy and consent to the collection, use, and disclosure of your personal information."
    }
    ],

    how:    [
    {
    "sn": 1,
    "text": "Dial *577*8012*1# on your mobile phone with a GLO SIM to make a subscription."
    },
    {
    "sn": 2,
    "text": "Receive a subscription confirmation message."
    },
    {
    "sn": 3,
    "text": "Visit <a href='http://games.9ijakids.com' class='text-blue-400 underline font-semibold'>(http://games.9ijakids.com)<a/> and log in with your GLO number."
    },
    {
    "sn": 4,
    "text": "Select any game of your choice or use filters to find games by class and subject. You can also search for games by their name."
    },
    {
    "sn": 5,
    "text": "Carefully read the instructions or watch the tutorial video on how to play the game."
    },
    {
    "sn": 6,
    "text": "Answer questions and learn along the way while having fun with the game."
    },
    {
    "sn": 7,
    "text": "Check your position on the leaderboard after the game ends."
    },
    {
    "sn": 8,
    "text": "Remember: Learning can be fun; only curious minds become great learners!"
    }
    ]
    
};
